export const APPLICATION_ID =
  "Informação acessível após a conclusão da análise do processo";
export const JUST_ONE_PROCESS = "Você deve selecionar apenas um processo.";
export const PASSPORT_WITHOUT_NAME =
  "Se o seu passaporte não incluir um nome, digite 'FNU' no campos.";
export const SURNAMES_LIKE_PASSPORT =
  "Digite todos os sobrenomes conforme listados em seu passaporte. Se apenas um nome estiver listado em seu passaporte, digite esse sobrenome.";
export const SAVED_PROCESS = "Aplicações que ainda não estão em análise";
export const APPLICATION_NOT_ABLE_TO_SEND = "Está aplicação ainda possui campos em branco!";
export const APPLICATION_WITHOUT_SUBSCRIPTION = "Você está sem aplicações disponiveis, consulte a nossa página de compra."